angular.module('paymentdeadlines', ['core'])
    .factory('PaymentDeadline', function ($resource) {
        return $resource('/crm/api/payment-deadlines/:id', {}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/payment-deadlines/table'},
            autocomplete: {method: 'GET', isArray: true},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('PaymentDeadlineService', function ($rootScope, toastr, modals, PaymentDeadline, $filter) {
        this.edit = id => {
            PaymentDeadline.get({id: id}).$promise.then(entity => editModal(entity));
        }
        this.add = () => {
            let entity = {
                active: true,
                id: null
            };
            return editModal(entity);
        };
        this.remove = item => {
            return modals.confirmDelete(`${item.value} ${$filter("localized")(item.name)}`, () => PaymentDeadline.delete({id: item.id}, () => $rootScope.$broadcast('paymentdeadline.updated')).$promise);
        };

        function editModal(entity) {
            return modals.open('app/payment-deadline/edit-modal.html', 'PaymentDeadlineDialogController', entity, {size: 'md'}, "$ctrl");
        }
    })
    .component('paymentDeadlineList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/payment-deadline/list.html',
        controller: function ($scope, $state, PaymentDeadlineService) {
            this.reset = () => this.filters = {}
            this.PaymentDeadlineService = PaymentDeadlineService

            $scope.$on('paymentdeadline.updated', () => $state.reload())
        }
    })
    .controller('PaymentDeadlineDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, PaymentDeadline) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = PaymentDeadline.update(this.item).$promise
            } else {
                promise = PaymentDeadline.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('paymentdeadline.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('paymentDeadlineList', {
            parent: 'app',
            url: '/payment-deadline?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "paymentDeadlineList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (PaymentDeadline, $q, $stateParams) => PaymentDeadline.table(angular.copy($stateParams)).$promise
            }
        });
    });
